import React from 'react'

export const Loader = ({ size = '5rem' }) => {
  return (
    <div style={{ paddingBottom: '24px' }}>
      <div
        className="spinner-border"
        style={{ width: size, height: size }}
        role="status"
      >
        <span className="sr-only"></span>
      </div>
    </div>
  )
}
export default Loader
